import { render, staticRenderFns } from "./ShopWindowComponent.vue?vue&type=template&id=07a6a090"
import script from "./ShopWindowComponent.vue?vue&type=script&lang=js"
export * from "./ShopWindowComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports